export const keyShiftEdges = {
  'shift+up': 'top',
  'shift+right': 'right',
  'shift+down': 'bottom',
  'shift+left': 'left',
};
